import React, { useState, useEffect } from "react"
import ReactMarkdown from "react-markdown"
import moment from "moment"
// import { Link as GatsbyLink } from "gatsby"
import Lightbox from "yet-another-react-lightbox"
import Captions from "yet-another-react-lightbox/dist/plugins/captions"
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen"
import Slideshow from "yet-another-react-lightbox/dist/plugins/slideshow"
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails"
import Video from "yet-another-react-lightbox/dist/plugins/video"
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom"
import "yet-another-react-lightbox/dist/plugins/captions/captions.css"
import "yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css"
import "yet-another-react-lightbox/dist/styles.css"
import { useMediaPredicate } from "react-media-hook"

import { Link } from "gatsby"

import { Container } from "../grid/grid"
import { Card } from "../card/card"
import { HeadingBasic } from "../heading/heading"
import { CardSlider } from "../card-slider/card-slider"
import { ButtonLink, replaceUnicode } from "./utils"
import { CardProject } from "../card-project/card-project"

import { Glider } from "../glider/glider"

const getPropertyTypeName = (data, lang) => {
  const isNonEnglish = lang !== "EN";
  const propertyTypes = isNonEnglish ? data.translation?.propertyTypes : data.propertyTypes;
  const nodes = propertyTypes?.nodes || [];

  if (nodes.length > 1 && nodes[0]?.name === "Infinite Living") {
    return nodes[1]?.name;
  }

  return nodes[0]?.name;
};

export const ProjectsByLocation = ({ data, location, lang, filteredLocations }) => {
  let locations = []
  let projects = []
  let gliderData = []

  const group = data?.reduce((result, currentValue) => {
    if (currentValue?.locations?.nodes[0]) {
      ;(result[currentValue["locations"]["nodes"][0]["name"]] =
        result[currentValue["locations"]["nodes"][0]["name"]] || []).push(
        currentValue
      )
    }
    return result
  }, {})

  locations = group && Object.keys(group)
  projects = group && Object.values(group)

  if (locations && locations.length > 0) {
    const getProjectLink = (data, location) => {
      const propertyTypeSlug = data.propertyTypes.nodes[0]?.slug
      const projectLocationSlug = data.locations.nodes[0]?.slug
      if (propertyTypeSlug === "properti" || propertyTypeSlug === "kavling" || propertyTypeSlug === "doubledream-property") {
        return `${location}/${projectLocationSlug}/${data.slug}`
      } else if (data.slug && location) {
        return `${location}/${data.slug}`
      } else {
        return "/"
      }
    }

    const renderViewAllLink = data => {
      const propertyTypeSlug = data[0]?.propertyTypes?.nodes[0]?.slug
      if (propertyTypeSlug === "properti" || propertyTypeSlug === "kavling") {
        return (
          <div className="container text-right">
            <Link
              to={`${location}/${data[0]?.locations?.nodes[0]?.slug}`}
              className="btn btn-link font-size-lg fx-underline"
            >
              View all &gt;&gt;
            </Link>
          </div>
        )
      } else {
        return
      }
    }

    if (locations.length > 0) {
      locations.map((item, i) => {
        let arr = []
        projects[i].map((data, index) => {
          arr.push({
            image: data.featuredImage
              ? data.featuredImage.sourceUrl
              : "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main-2.jpg",
            propertyName:
              lang === "EN"
                ? data.title
                : data?.translation?.title || data.title,
            type: getPropertyTypeName(data, lang),
            location: data.locations.nodes[0].name || null,
            description:
              lang === "EN"
                ? data?.excerpt
                : data?.translation?.excerpt || data?.excerpt,
            linkTo: getProjectLink(data, location),
            pathnameProject: location,
          })
          return 1
        })

        gliderData.push(arr)
      })
    }

    const findLocation = location => {
      return (
        locations &&
        locations.length > 0 &&
        locations.map((item, i) => {
          if (item === location) {
            return (
              <section key={`nearby-${item}-${i}`} className={"pb-main overflow-x-hidden overflow-y-hidden"}>
                <div className="container">
                  <HeadingBasic h2={item} />
                </div>
                <div className="container px-sm-down-0">
                  <Glider id="nearby" data={gliderData[i]} />
                </div>
                {renderViewAllLink(projects[i])}
              </section>
            )
          }
          return null
        })
      )
    }

    let listOfLocations = ["BSD City", "Jakarta", "Bogor", "Tangerang", "Depok", "Bekasi", 
    "Cikarang", "Cibubur", "Surabaya", "Balikpapan", "Batam", "Karawang", "Medan", "Semarang", ]

    return (
      (locations && (
        <div className="py-main">
          {filteredLocations ? (
            findLocation(filteredLocations)
          ) : (
            listOfLocations.map(item =>
              findLocation(item)
            )
          )}
          {/* {findLocation("BSD City")}
          {findLocation("Jakarta")}
          {findLocation("Bogor")}
          {findLocation("Tangerang")}
          {findLocation("Depok")}
          {findLocation("Bekasi")}
          {findLocation("Cikarang")}
          {findLocation("Cibubur")}
          {findLocation("Surabaya")}
          {findLocation("Balikpapan")}
          {findLocation("Batam")}
          {findLocation("Karawang")}
          {findLocation("Medan")}
          {findLocation("Semarang")} */}
          {/* {locations.length > 0 &&
            locations.map((item, i) => {
              if (item !== "International Projects") {
                return (
                  <section key={`nearby-${item}-${i}`} className={"pb-main"}>
                    <div className="container">
                      <HeadingBasic h2={item} />
                    </div>
                    <div className="container px-sm-down-0">
                      <Glider id="nearby" data={gliderData[i]} />
                    </div>
                    {renderViewAllLink(projects[i])}
                  </section>
                )
              }
              return null
            })} */}
          {locations.length > 0 &&
            locations.map((item, i) => {
              if (item === "International Projects") {
                return (
                  <section
                    key={`nearby-${item}-${i}`}
                    className={`${i > 0 ? "pb-main" : "py-main"} overflow-x-hidden overflow-y-hidden`}
                  >
                    <div className="container">
                      <HeadingBasic h2={item} />
                    </div>
                    <div className="container px-sm-down-0">
                      <Glider id="nearby" data={gliderData[i]} />
                    </div>
                  </section>
                )
              } else {
                return <div></div>
              }
            })}
        </div>
      )) || <div></div>
    )
  } else {
    return <div></div>
  }
}

export const Carousel = ({ data, withLightbox, withButtonWa }) => {
  const resizeScreen = useMediaPredicate("(max-width: 992px)")
  const now = moment().format("YYYY-MM-DD")
  const [openLightBox, setOpenLightBox] = useState(false)

  if (data && data.acf && data.acf.carousel_type === "full") {
    let dataArr = []
    let dataImgLightBox = []
    data.acf.images &&
      data.acf.images.map((item, i) => {
        dataArr.push({ image: item.sourceUrl })
        dataImgLightBox.push({ 
          src: item.sourceUrl, 
          title: item?.title ? item.title : "", 
          description: item?.description ? item.description : ""
        })
      })

    return (
      <Container className="px-sm-down-0 overflow-x-hidden">
        {withLightbox && (
          <>
            <div className="col-lg-12 fullscreen-btn-wrapper" style={{position: `relative`}}>
              <button className="btn btn-primary fullscreen-gallery" aria-label="fullscreen" onClick={() => setOpenLightBox(true)}>
                <i className="fas fa-expand"></i>
              </button>
            </div>
            
            <Lightbox
              toolbar={{
                buttons: [
                  <button 
                    className="yarl__button btn btn-primary-whatsapp"
                    onClick={withButtonWa}>
                    {resizeScreen ? (
                        <>
                          Whatsapp
                        </>
                      ):(
                        <>
                          <i className="fab fa-whatsapp"></i>&nbsp;&nbsp;&nbsp;Whatsapp
                        </>
                      )}
                  </button>,
                  "close",
                ],
              }}
              styles={{ thumbnailsTrack: {display: "none"} }}
              open={openLightBox}
              close={() => setOpenLightBox(false)}
              slides={dataImgLightBox}
              plugins={[Captions, Fullscreen, Slideshow, Thumbnails, Video, Zoom]}
            />
          </>
        )}
        {withLightbox ? (
          <CardSlider
            showInitial={1}
            showLgDown={1}
            showMdDown={1}
            showSmDown={1}
            arrowsSmDown={true}
            arrowsMdDown={true}
            visibleInitial={false}
            visibleLgDown={false}
          >
            {data.acf.images &&
              data.acf.images.map((item, i) => {
                return (
                  <Card
                    key={`${item.sourceUrl}-${i}`}
                    variant="boxless"
                    img={item.sourceUrl}
                    imgHeight="h-ratio-2-1"
                    caption={item?.caption ? item?.caption : ""}
                    clickable={() => setOpenLightBox(true)}
                    clickableClassName="cursor-clickable"
                  />
                )
              })}
          </CardSlider>
        ):(
          <CardSlider
            showInitial={1}
            showLgDown={1}
            showMdDown={1}
            showSmDown={1}
            arrowsSmDown={true}
            arrowsMdDown={true}
            visibleInitial={false}
            visibleLgDown={false}
          >
            {data.acf.images &&
              data.acf.images.map((item, i) => {
                return (
                  <Card
                    key={`${item.sourceUrl}-${i}`}
                    variant="boxless"
                    img={item.sourceUrl}
                    imgHeight="h-ratio-2-1"
                    caption={item?.caption ? item?.caption : ""}
                  />
                )
              })}
          </CardSlider>
        )}
      </Container>
    )
  } else if (data && data.acf && data.acf.carousel_type === "compact") {
    let length = 0
    let hasExpiredDate =
      data.acf &&
      data.acf.images &&
      data.acf.images.some(x => x.acfAttachment.expired !== null)
    data.acf &&
      data.acf.images &&
      data.acf.images.map(item => {
        const dateArr =
          item.acfAttachment.expired && item.acfAttachment.expired.split("/")
        const formatDate =
          dateArr && [dateArr[2], dateArr[1], dateArr[0]].join("-")

        if (item.acfAttachment.expired && moment(formatDate).isAfter(now)) {
          length++
        } else {
          return -1
        }
        return 1
      })

    return (
      <CardSlider className={'overflow-x-hidden'}>
        {hasExpiredDate &&
          length > 0 &&
          data.acf.images.map((item, i) => {
            const dateArr = item.acfAttachment.expired.split("/")
            const formatDate = [dateArr[2], dateArr[1], dateArr[0]].join("-")
            if (item.acfAttachment.expired && moment(formatDate).isAfter(now)) {
              return (
                <Card
                  key={`${item.title}-${i}`}
                  variant="boxless"
                  title={item.title}
                  titleClassName="h6"
                  text={item.description}
                  img={item.sourceUrl || data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
              )
            } else if (!item.acfAttachment.expired) {
              return (
                <Card
                  key={`${item.title}-${i}`}
                  variant="boxless"
                  title={item.title}
                  titleClassName="h6"
                  text={item.description}
                  img={item.sourceUrl || data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
              )
            }
            return ""
          })}
        {!hasExpiredDate &&
          data.acf.images &&
          data.acf.images.map((item, i) => {
            return (
              <Card
                key={`${item.title}-${i}`}
                variant="boxless"
                title={item.title}
                titleClassName="h6"
                text={item.description}
                img={item.sourceUrl || data.imgCover.childImageSharp.fluid}
                imgHeight="h-ratio-1-1"
              />
            )
          })}
      </CardSlider>
    )
  } else {
    let detail = []
    data.acf !== undefined &&
      data.acf.images.map(item => {
        detail.push({
          image: item.sourceUrl
            ? item.sourceUrl
            : "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main.jpg",
          propertyName: item.title,
          location: item.acfAttachment.location,
          description: item.description,
        })
      })

    const Slider = ({ data }) => {
      if (data.length === 1) {
        return (
          <>
            <div className="row row-0">
              <CardProject
                title={data[0].propertyName ? data[0].propertyName : null}
                description={
                  data[0].description ||
                  "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                }
                img={data[0].image || null}
                category={data[0].type || null}
                location={data[0].location || null}
                link={data[0].linkTo || "/"}
                className="col-md-12 px-0"
              />
            </div>
          </>
        )
      } else if (data.length > 1 && data.length <= 3) {
        return (
          <>
            <div className="d-none d-md-block">
              <div className="row">
                {data.map((item, i) => {
                  return (
                    <CardProject
                      key={`${item.propertyName}-${i}`}
                      title={item.propertyName || null}
                      description={
                        item.description ||
                        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                      }
                      img={item.image || null}
                      category={item.type || null}
                      location={item.location || null}
                      link={item.linkTo || "/"}
                      className="px-sm-down-0 col ratio-1-1"
                    />
                  )
                })}
              </div>
            </div>
            <div className="glide d-md-none">
              <CardSlider>
                {data.map((item, index) => (
                  <CardProject
                    title={item.propertyName || null}
                    description={
                      item.description ||
                      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                    }
                    img={item.image || null}
                    category={item.type || null}
                    location={item.location || null}
                    link={item.linkTo || "/"}
                    col="4"
                    className="px-sm-down-0 ratio-1-1"
                  />
                ))}
              </CardSlider>
            </div>
          </>
        )
      } else {
        return (
          <CardSlider>
            {data.map((item, index) => (
              <CardProject
                key={`${item.propertyName}-${index}`}
                title={item.propertyName || null}
                description={
                  item.description ||
                  "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                }
                img={item.image || null}
                category={item.type || null}
                location={item.location || null}
                link={item.linkTo || "/"}
                col="4"
                className="px-sm-down-0 ratio-1-1"
              />
            ))}
          </CardSlider>
        )
      }
    }

    return <Slider data={detail} />
  }
}

export const WpIconlist = ({ data }) => {
  return (
    <section className="values">
      <div className="row">
        {data?.acf?.list?.map((item, i) => (
          <div key={`${item.title}-${i}`} className="col-lg-6">
            <div className="value-item">
              <img alt="img" src={item.icon && item.icon.sourceUrl}  width={`90`} height={`90`}/>
              <div>
                <p className="header">
                  <strong>{item.title}</strong>
                </p>
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export const WpFacilitiesIcon = ({ data }) => {
  return (
    <section className="smartmove-facilities">
      <div className="row">
        {data?.acf?.list?.map((item, i) => (
          <div key={`${item.title}-${i}`} className="col-xs-4 col-sm-4 col-lg-3">
            <div className="value-item">
              <img alt="img" src={item.icon && item.icon.sourceUrl} width="80" height="80"/>
              <div>
                <p className="header">
                  <strong>{item.title}</strong>
                </p>
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export const WpImagelistkey = ({ data, variant }) => {
  let listItem = [];

  if (variant === 'inline-style') {
    listItem = data.acf.list.map((item, i) => (
      <span
        key={`${item.title}-${i}`}
        className={"performa-key"}
      >
        <img alt="icon" src={item.img && item.img.sourceUrl} />
        <h3>{item.title}</h3>
        <p>{item.text}</p>
      </span>
    ));
  } else {
    listItem = data.acf.list.map((item, i) => (
      <a
        key={`${item.title}-${i}`}
        className={data.acf.list.length > 1 && i === (data.acf.list.length - 1) ? "performa-key left-tooltip" : "performa-key" }
        href="javascript:void(0)"
        rel="noopener noreferrer"
        draggable="false"
        data-tooltip={item.text}
      >
        <img alt="icon" src={item.img && item.img.sourceUrl} />
        <p>{item.title}</p>
      </a>
    ));
  }

  return (
    <>
       <section className="performa-key-title col-md-12">
         <h2>{data.acf.title}</h2>
       </section>
       <section className={`performa-key-wrapper ${variant}`}>
         {listItem}
       </section>
    </>
  )
}

export const Stats = ({ data }) => {
  return (
    <section className="stats">
      <section className="sc-stats py-main-sm">
        <div className="container container-md">
          <div className="row">
            {data.acf &&
              data.acf.list_label_values.length > 0 &&
              data.acf.list_label_values.map((item, i) => {
                return (
                  <div key={`stats-labels-${i}`} className="col-3 col-lg">
                    <div className="stats-item">
                      <div className="stats-item-numbers">{item.value}</div>
                      <div className="stats-item-unit">{item.label}</div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </section>
    </section>
  )
}

export const WpGroup = ({ data, lang }) => {
  const [render, setRender] = useState(true)
  let paragraphs = []

  data.innerBlocks.map((item, i) => {
    if (item.name === "core/paragraph") {
      paragraphs.push(item.attributes.content)
    }
    return -1
  })

  if (render) {
    return (
      <section>
        <div className={`container container-md`}>
          {data.innerBlocks.map((item, i) => {
            switch (item.name) {
              case "core/paragraph":
                return (
                  <div
                    key={`inner-paragraph-${i}`}
                    className="heading heading-basic"
                  >
                    <ReactMarkdown
                      source={item.attributes.content}
                      escapeHtml={false}
                    />
                  </div>
                )
              case "core/heading":
                return (
                  <div
                    key={`inner-heading-${item.attributes.content}${i}`}
                    className="heading heading-basic"
                  >
                    <h2>{replaceUnicode(item.attributes.content)}</h2>
                  </div>
                )
              case "core/buttons":
                return <ButtonLink lang={lang} item={item} key={`inner-buttons${i}`} />
              case "acf/iconlist":
                return (
                  <WpIconlist key={`innerblocks-iconlist-${i}`} data={item} />
                )
              case "acf/labelvalues":
                return (
                  <Stats key={`innerblocks-${item.name}-${i}`} data={item} />
                )
              case "acf/acfgallery":
                if (item.acf.carousel_type === "compact") {
                  const now = moment().format("YYYY-MM-DD")
                  let length = 0
                  let hasExpiredDate =
                    data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.some(x => x.acfAttachment.expired !== null)

                  data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.map(item => {
                        const dateArr =
                          item.acfAttachment.expired &&
                          item.acfAttachment.expired.split("/")
                        const formatDate =
                          dateArr &&
                          [dateArr[2], dateArr[1], dateArr[0]].join("-")

                        if (
                          item.acfAttachment.expired &&
                          moment(formatDate).isAfter(now)
                        ) {
                          length++
                        } else {
                          return -1
                        }
                        return 1
                      })

                  if (length === 0 && hasExpiredDate) {
                    setRender(false)
                  }
                }
                return (
                  <div key={`innerblocks-carousel-${i}`} className="py-3">
                    <Carousel data={item} />
                  </div>
                )
              case "core/list":
                return (
                  <div className="heading heading-basic">
                    <ul>
                      <ReactMarkdown
                        source={item.attributes.values}
                        escapeHtml={false}
                      />
                    </ul>
                  </div>
                )
              default:
                return <div key={`empty-${i}`}></div>
            }
          })}
        </div>
      </section>
    )
  } else {
    return <div></div>
  }
}

export const WpGroupSmartMove = ({ data, lang }) => {
  const [render, setRender] = useState(true)
  let paragraphs = []
  // let charchecker = ""

  data.innerBlocks.map((item, i) => {
    if (item.name === "core/paragraph") {
      paragraphs.push(item.attributes.content)
    }
    return -1
  })

  // paragraphs.toString()
  // console.log("ngecekParagraph === ", paragraphs.length)

  const toggleDetailPara = () => {
    let panel = document.getElementById("details-para")
    let iconBtn = document.getElementById("icon-details-btn")
    let overlayText = document.getElementById("overlay-text")
    let infoDesc = document.getElementById("info-details-desc")
    if(lang === "EN"){
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
        overlayText.style.backgroundImage = "linear-gradient(0deg,#fff,hsla(0,0%,100%,.5))"
        iconBtn.classList.remove("fa-chevron-up")
        iconBtn.classList.add("fa-chevron-down")
        infoDesc.innerHTML = "Show More"
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        overlayText.style.backgroundImage = "none"
        iconBtn.classList.remove("fa-chevron-down")
        iconBtn.classList.add("fa-chevron-up")
        infoDesc.innerHTML = "Show Less"
      }
    }else{
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
        overlayText.style.backgroundImage = "linear-gradient(0deg,#fff,hsla(0,0%,100%,.5))"
        iconBtn.classList.remove("fa-chevron-up")
        iconBtn.classList.add("fa-chevron-down")
        infoDesc.innerHTML = "Tampilkan Lebih Banyak"
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        overlayText.style.backgroundImage = "none"
        iconBtn.classList.remove("fa-chevron-down")
        iconBtn.classList.add("fa-chevron-up")
        infoDesc.innerHTML = "Tampilkan Lebih Sedikit"
      }
    } 
  }

  if (render) {
    return (
      <section className="group-section-wrapper">
        <div className={`container container-md ${data?.attributes?.className === "details-paragraph" ? "details-para": "mh-100"}`} id={`${data?.attributes?.className === "details-paragraph" ? "details-para": ""}`}>
          {data.innerBlocks.map((item, i) => {
            switch (item.name) {
              case "core/paragraph":
                return (
                  <div
                    key={`inner-paragraph-${i}`}
                    className="heading heading-basic"
                  >
                    <ReactMarkdown
                      source={item.attributes.content}
                      escapeHtml={false}
                    />
                  </div>
                )
              case "core/heading":
                return (
                  <div
                    key={`inner-heading-${item.attributes.content}${i}`}
                    className="heading heading-basic"
                  >
                    <h2>{replaceUnicode(item.attributes.content)}</h2>
                  </div>
                )
              case "core/buttons":
                return <ButtonLink lang={lang} item={item} key={`inner-buttons${i}`} />
              case "acf/iconlist":
                return (
                  <WpIconlist key={`innerblocks-iconlist-${i}`} data={item} />
                )
              case "acf/labelvalues":
                return (
                  <Stats key={`innerblocks-${item.name}-${i}`} data={item} />
                )
              case "acf/acfgallery":
                if (item.acf.carousel_type === "compact") {
                  const now = moment().format("YYYY-MM-DD")
                  let length = 0
                  let hasExpiredDate =
                    data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.some(x => x.acfAttachment.expired !== null)

                  data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.map(item => {
                        const dateArr =
                          item.acfAttachment.expired &&
                          item.acfAttachment.expired.split("/")
                        const formatDate =
                          dateArr &&
                          [dateArr[2], dateArr[1], dateArr[0]].join("-")

                        if (
                          item.acfAttachment.expired &&
                          moment(formatDate).isAfter(now)
                        ) {
                          length++
                        } else {
                          return -1
                        }
                        return 1
                      })

                  if (length === 0 && hasExpiredDate) {
                    setRender(false)
                  }
                }
                return (
                  <div key={`innerblocks-carousel-${i}`} className="py-3">
                    <Carousel data={item} />
                  </div>
                )
              case "core/list":
                return (
                  <div className="heading heading-basic">
                    <ul>
                      <ReactMarkdown
                        source={item.attributes.values}
                        escapeHtml={false}
                      />
                    </ul>
                  </div>
                )
              default:
                return <div key={`empty-${i}`}></div>
            }
          })}
        </div>
        {data?.attributes?.className === "details-paragraph" && (
          <div className="container container-md">
            <div className="overlay-text" id="overlay-text"></div>
            <p className="details-plc-btn" id="details-plc-btn">
              <button 
                className="btn isdetail-btn" 
                id="is-detail-btn" 
                onClick={() => toggleDetailPara()}
              >
                <span id="info-details-desc">{lang === "EN" ? "Show More": "Tampilkan Lebih Banyak"}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <i className="fa fa-chevron-down" id="icon-details-btn"></i>
              </button>
            </p>
          </div>
        )}
      </section>
    )
  } else {
    return <div></div>
  }
}

export const WpSusDetailGroup = ({ data, lang }) => {
  const [render, setRender] = useState(true)
  let paragraphs = []

  data.innerBlocks.map((item, i) => {
    if (item.name === "core/paragraph") {
      paragraphs.push(item.attributes.content)
    }
    return -1
  })

  if (render) {
    return (
      <section>
        <div className={`container container-md sus-detail`}>
          {data.innerBlocks.map((item, i) => {
            switch (item.name) {
              case "core/paragraph":
                return (
                  <div
                    key={`inner-paragraph-${i}`}
                    className="heading heading-basic"
                  >
                    <ReactMarkdown
                      source={item.attributes.content}
                      escapeHtml={false}
                    />
                  </div>
                )
              case "core/heading":
                return (
                  <div
                    key={`inner-heading-${item.attributes.content}${i}`}
                    className="heading heading-basic"
                  >
                    <h2>{replaceUnicode(item.attributes.content)}</h2>
                  </div>
                )
              case "core/buttons":
                return <ButtonLink lang={lang} item={item} key={`inner-buttons${i}`} />
              case "acf/iconlist":
                return (
                  <WpIconlist key={`innerblocks-iconlist-${i}`} data={item} />
                )
              case "acf/labelvalues":
                return (
                  <Stats key={`innerblocks-${item.name}-${i}`} data={item} />
                )
              case "acf/acfgallery":
                if (item.acf.carousel_type === "compact") {
                  const now = moment().format("YYYY-MM-DD")
                  let length = 0
                  let hasExpiredDate =
                    data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.some(x => x.acfAttachment.expired !== null)

                  data.innerBlocks.find(x => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find(x => x.name === "acf/gallery")
                      .acf.images.map(item => {
                        const dateArr =
                          item.acfAttachment.expired &&
                          item.acfAttachment.expired.split("/")
                        const formatDate =
                          dateArr &&
                          [dateArr[2], dateArr[1], dateArr[0]].join("-")

                        if (
                          item.acfAttachment.expired &&
                          moment(formatDate).isAfter(now)
                        ) {
                          length++
                        } else {
                          return -1
                        }
                        return 1
                      })

                  if (length === 0 && hasExpiredDate) {
                    setRender(false)
                  }
                }
                return (
                  <div key={`innerblocks-carousel-${i}`} className="py-3">
                    <Carousel data={item} />
                  </div>
                )
              case "core/list":
                return (
                  <div className="heading heading-basic">
                    <ul style={{paddingInlineStart: "20px"}}>
                      <ReactMarkdown
                        source={item.attributes.values}
                        escapeHtml={false}
                      />
                    </ul>
                  </div>
                )
              default:
                return <div key={`empty-${i}`}></div>
            }
          })}
        </div>
      </section>
    )
  } else {
    return <div></div>
  }
}

export const WpCaseStudyGroup = ({ data }) => {
  const [render, setRender] = useState(true)
  const resizeScreen = useMediaPredicate("(max-width: 992px)")

  useEffect(() => {
    const newDiv = document.createElement("div")
    const thisImgGroup = document.querySelectorAll(".img-sr-group")
    const thisTrigger = document.querySelector(".img-group-wrapper")
    newDiv.setAttribute("id", "img-group-wrapper")
    if (thisTrigger){
      thisTrigger.appendChild(newDiv)
    }
    if (thisImgGroup){
      for (var i = 0; i < thisImgGroup.length ; i++) {
        newDiv.insertAdjacentElement("afterend",thisImgGroup[i])
      }
    }
  }, [])

  if (render) {
    return (
      <section>
        <div className={`container container-md`}>
          {data.innerBlocks.map((item, i) => {
            switch (item.name) {
              case "core/paragraph":
                return (
                  <div
                    key={`inner-paragraph-${i}`}
                    className={`heading heading-basic mw-100
                      ${resizeScreen
                        ? item.attributes.className === "paragraph-list" ? "text-left pl-1-point-5" : "text-left" 
                        : item.attributes.className === "paragraph-list" ? "text-left pl-1-point-5" : "text-left"
                      }
                    `}
                  >
                    <ReactMarkdown
                      source={item.attributes.content}
                      escapeHtml={false}
                    />
                  </div>
                )
              case "core/heading":
                return (
                  <div
                    key={`inner-heading-${item.attributes.content}${i}`}
                    className="heading heading-basic"
                    style={{maxWidth:"100%"}}
                  >
                    {item.attributes.className == "heading1" && <h1>{replaceUnicode(item.attributes.content)}</h1>}
                    {item.attributes.className == "heading2" && <h2>{replaceUnicode(item.attributes.content)}</h2>}
                    {item.attributes.className == "heading3" && <h3>{replaceUnicode(item.attributes.content)}</h3>}
                    {item.attributes.className == "heading4" && <h4>{replaceUnicode(item.attributes.content)}</h4>}
                    {item.attributes.className == "heading5" && <h5>{replaceUnicode(item.attributes.content)}</h5>}
                  </div>
                )
              case "core/image":
                return (
                  <>
                  {item.attributes.className === "img-group" && (<div className="img-group-wrapper"></div>)}
                  <div key={`core-image-${i}`} className={item.attributes.className === "img-group"? "pb-4 img-sr-group" : "pb-4"}>
                    <img
                      alt="image"
                      src={item.attributes.url}
                      className="img-fluid"
                    />
                    <p key={`caption-${i}`} dangerouslySetInnerHTML={{ __html: item?.attributes?.caption}} />
                  </div>
                  </>
                )
              case "core/buttons":
                return <ButtonLink item={item} key={`inner-buttons${i}`} />
              case "acf/iconlist":
                return (
                  <WpIconlist key={`innerblocks-iconlist-${i}`} data={item} />
                )
              case "acf/labelvalues":
                return (
                  <Stats key={`innerblocks-${item.name}-${i}`} data={item} />
                )
              case "acf/acfgallery":
                if (item.acf.carousel_type === "compact") {
                  const now = moment().format("YYYY-MM-DD")
                  let length = 0
                  let hasExpiredDate =
                    data.innerBlocks.find((x) => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find((x) => x.name === "acf/gallery")
                      .acf.images.some((x) => x.acfAttachment.expired !== null)

                  data.innerBlocks.find((x) => x.name === "acf/gallery") &&
                    data.innerBlocks
                      .find((x) => x.name === "acf/gallery")
                      .acf.images.map((item) => {
                        const dateArr =
                          item.acfAttachment.expired &&
                          item.acfAttachment.expired.split("/")
                        const formatDate =
                          dateArr &&
                          [dateArr[2], dateArr[1], dateArr[0]].join("-")

                        if (
                          item.acfAttachment.expired &&
                          moment(formatDate).isAfter(now)
                        ) {
                          length++
                        } else {
                          return -1
                        }
                        return 1
                      })

                  if (length === 0 && hasExpiredDate) {
                    setRender(false)
                  }
                }
                return (
                  <div key={`innerblocks-carousel-${i}`} className="py-3">
                    <Carousel data={item} />
                  </div>
                )
              case "core/list":
                return (
                  <div className={`heading heading-basic mw-100 text-left`} 
                  >
                    {item.attributes.className == "disklist" &&(
                      <ul style={{paddingLeft:"20px"}}>
                        <ReactMarkdown
                          source={item.attributes.values}
                          escapeHtml={false}
                        />
                      </ul>
                    )}
                    {item.attributes.className == "numberlist" &&(
                      <ul style={{listStyleType:"number"}}>
                        <ReactMarkdown
                          source={item.attributes.values}
                          escapeHtml={false}
                        />
                      </ul>
                    )}
                  </div>
                )
              default:
                return <div key={`empty-${i}`}></div>
            }
          })}
        </div>
      </section>
    )
  } else {
    return <div></div>
  }
}

export const WpImagelistFocusArea = ({ data }) => {
  if(!data?.acf?.list?.length) return false
  return (
    <>
      <div>
        {data.acf.list.map((item, i) => (
          <div className="row col-md-12 list-img-fa" key={`${item.title}-${i}`}>
            <div className="col-md-4 section-img-fa">
              <img src={item.img && item.img.sourceUrl} style={{width:"100%"}} alt={`thumb-${i}`}/>
            </div>
            <div className="col-md-8 section-details-fa">
              <div className="col-md-12 title-fa">{item.title}</div>
              <div className="col-md-12 desc-fa">{item.text}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
